import { RootState } from 'config/store';

export const selectPromoKeyboardShortcutsEnabled = (state: RootState) =>
  state.uiPersist.promoKeyboardShortcuts;
